import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Kartable_Order_Interface, Kartable_Order_Interface } from 'src/app/Interface/Kartable_Order_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { KartableService } from 'src/app/Service/Kartable/Kartable.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-KartableCertificate',
  templateUrl: './KartableCertificate.component.html',
  styleUrls: ['./KartableCertificate.component.scss']
})
export class KartableCertificateComponent implements OnInit {

  Token: String = ""
  PersianToDayDate: String = ""
  BaseUrl = environment.BaseUrl


  Filter_Customer_Order: string = ""
  Filter_RecieveCode_Order: string = ""
  Filter_Certificate_User: string = ""

  Filter_Code2_Order: string = ""
  Filter_Devicename_Order: string = ""
  Filter_Expert_Name_Order: string = ""
  
  Filter_Device_Code: string = ""
  Filter_Device_Serial: string = ""
  
  SubmitPeriodDate: string = '0'

  page_Kartable: 0


  constructor(
    private Kartable_Service: KartableService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private modalService: BsModalService
  ) { }


  Change_Filter_Order() {
    this.page_Kartable = 0
  }


  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token, 2188).subscribe(
      data => {

      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )
  }


  Procssing_Kartable: boolean = false
  DataList_Kartable: Array<Kartable_Order_Interface> = []
  DataList_Kartable_Selected: Kartable_Order_Interface = Empty_Kartable_Order_Interface()
  Data_Seleted_Delete_Status: number = 0
  OperationDsc: string = ''
  modalRef_Delete: any;

  ReadData_Kartable(StartSearchDate, EndSearchDate) {
    this.Procssing_Kartable = true
    this.Kartable_Service.GetCertificate(this.Filter_Customer_Order,
      this.Filter_Expert_Name_Order,
      this.Filter_RecieveCode_Order,
      this.Filter_Code2_Order,
      this.Filter_Devicename_Order,
      Number(this.SubmitPeriodDate),
      StartSearchDate,
      EndSearchDate,
      this.Token).subscribe(
        data => {
          this.DataList_Kartable = data

          this.Procssing_Kartable = false
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
  }

  SetCalibrationDetailVisible(item: Kartable_Order_Interface) {
    item.Processing = true

    this.Kartable_Service.SetCalibrationDetailVisible(item.id2, this.Token).subscribe(
      data => {
        item.expert_submit_date_visible = true
        item.Processing = false
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  openModal(template: TemplateRef<any>, Record: Kartable_Order_Interface, Status: number) {
    this.DataList_Kartable_Selected = Record
    this.OperationDsc = ""
    this.Data_Seleted_Delete_Status = Status
    this.modalRef_Delete = this.modalService.show(template);
  }



  //#region Device Behfa

  DataList_Kartable_Selected_DeviceBehfa: Kartable_Order_Interface = Empty_Kartable_Order_Interface()

  OnSet_Calibration_DeviceBehfa(item: Kartable_Order_Interface) {
    this.DataList_Kartable_Selected_DeviceBehfa = item
  }

  OnSet_Back_Calibration_DeviceBehfa() {
    this.DataList_Kartable_Selected_DeviceBehfa = Empty_Kartable_Order_Interface()
  }

  //#endregion


  //#region Controller
  Selected_DataList_Calibration: Kartable_Order_Interface = Empty_Kartable_Order_Interface()
  Controller_Data_List: Array<General_Interface> = []
  modalRef_Controller: any;

  openModal_Controller(template: TemplateRef<any>, item: Kartable_Order_Interface) {
    this.modalRef_Controller = this.modalService.show(template);
    this.Selected_DataList_Calibration = item
    this.Controller_Data_List = item.controller
  }

  //#endregion

  //#region Calibration Status
  Certificate_Dsc: string = ''
  modalRef_Certificate: any;
  Selected_DataList_Certificate: Kartable_Order_Interface = Empty_Kartable_Order_Interface();
  openModal_Certificate(template: TemplateRef<any>, item: Kartable_Order_Interface) {
    this.modalRef_Certificate = this.modalService.show(template);
    this.Selected_DataList_Certificate = item
    this.Certificate_Dsc=''
  }

  SubmitCertificate() {
    this.Procssing_Kartable = true
    this.modalRef_Certificate.hide()
    this.Kartable_Service.SubmitCertificate(this.Token,this.Selected_DataList_Certificate.calibration_detail_id,this.Certificate_Dsc).subscribe(
      data => {
        this.Procssing_Kartable = false

        if (data.id == -1) {
          this.Alertify_Service.ErrorMessage("A recovery request for this certificate already exists in the system.")
        }
        else if (data.id == -2) {
          this.Alertify_Service.ErrorMessage("No active workflow has been selected for certificate recovery.")
        }
        else if (data.id == -3) {
          this.Alertify_Service.ErrorMessage("System error.")
        }
        else if (data.id == -4) {
          this.Alertify_Service.ErrorMessage("You have no assigned position in the organizational chart.")
        }
        else {
          this.Alertify_Service.SuccessMessage("The request was submitted successfully.")
        }
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )


  }

  //#endregion


}
